import { AioExternalReplacements, AitRowGroupData, ARS } from "aic";
import axios from "axios";
import { AioExternalSingleWithSource } from "contexts/hierarchy/interface";
import { IEditorV3 } from "editor-v3";
import { processAxiosError } from "../processAxiosError";
import { DomainReplacements } from "./DomainReplacements";
import { HierarchyReadDto } from "./HierarchyReadDto";
import { ITocSection } from "./ITocSection";
import { HierarchyReadDtoDataReturn } from "./loadHierarchy";

export interface HierarchyCreateDto {
  parentId: string;
  parentParentTag: string;
  name: string;
  hierarchyTag: string;
  description: string;
  reportType: string;
  arsEnabled?: boolean;
}

export interface HierarchyUpdateDto {
  id: string;
  name: string;
  parentTag: string;
  description: string;
  lists?: AioExternalReplacements<IEditorV3>[];
  phase?: string;
  reportType?: string;
  rowGroups?: AitRowGroupData<IEditorV3>[];
  sections?: ITocSection[];
  singles?: AioExternalSingleWithSource<IEditorV3>[];
  status?: string;
  domainList?: string[];
  domainReplacements?: DomainReplacements[];
  arsEnabled?: boolean;
  analysisMethods?: ARS.AnalysisMethod[];
  analysisSets?: ARS.AnalysisSet[];
  dataSubsets?: ARS.DataSubset[];
  groupingFactors?: ARS.GroupingFactor[];
}

export type HierarchySaveDto = HierarchyCreateDto | HierarchyUpdateDto;

/**
 * Create or update a hierarchy.
 *
 * @param backEndUrl - Base backend URL
 * @param hierarchy - Hierarchy create or update DTO
 * @param controller - Optional AbortController
 * @returns The saved hierarchy wrapped in HierarchyReadDtoDataReturn
 */
export const saveHierarchyData = async (
  backEndUrl: string,
  hierarchy: HierarchySaveDto,
  controller?: AbortController,
): Promise<HierarchyReadDtoDataReturn> => {
  let url: string;
  let method: string;
  if (((hierarchy as HierarchyUpdateDto).id ?? "") !== "") {
    url = `${backEndUrl}Hierarchy/${(hierarchy as HierarchyUpdateDto).id}`;
    method = "PUT";
  } else {
    url = `${backEndUrl}Hierarchy`;
    method = "POST";
  }
  // Set headers, send method
  const headers = {
    "Content-Type": "application/json;charset=utf-8",
  };

  // Send data
  try {
    const response: { data: HierarchyReadDto } = await axios.request({
      method,
      url,
      data: hierarchy,
      headers,
      signal: controller?.signal,
    });
    // Return successful result
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("Save failed", error);
  }
};
